import { Outlet } from "react-router";
import Footer from "./Footer";
import ScrollToTop from "../../utils/ScrollToTop";
import Navbar from "./Navbar";
import Whatsapp from "../whatsapp/Whatsapp";
import BottomNavigation from "./BottomNavigation";

function RootLayout() {
  return (
    <>
      <ScrollToTop />
      {/* <div className="h-[80px]"></div> */}
      <Navbar />
      <Outlet />
      <Whatsapp />
      <BottomNavigation />
      <Footer />
    </>
  );
}

export default RootLayout;
